export const dummyRobotTableData = {
  site: 'SGH',
  site_address: '73 Ayer Rajah Crescent, #01-07, Singapore 139952',
  customer_name: 'John',
  customer_contact: '0892567328',
  organisation_name: 'Autove',
}